module.exports = __webpack_public_path__ + "4a7612ef1952bb8f52020ee8545dff10.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-1080.jpg
// module id = 338
// module chunks = 0